(function(){
  var box, form, cur, currency, FREE_FROM = 8000;
  function fmt(c){ var s=(c/100).toFixed(3).replace(/0+$/,'').replace(/\.$/,''); return s.replace('.', ',') + ' DT'; }
  function q(s){ return box.querySelector(s); }
  function evid(){ return 'lw_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10); }
  function cookie(n){ var m=document.cookie.match('(?:^|; )'+n+'=([^;]*)'); return m?decodeURIComponent(m[1]):''; }
  function orderRef(){
    var d = new Date(), p = function(n){ return (n<10?'0':'')+n; };
    var day = String(d.getFullYear()).slice(2) + p(d.getMonth()+1) + p(d.getDate());
    var rnd = Math.random().toString(36).slice(2,6).toUpperCase().replace(/[O0I1]/g,'X');
    return 'LW-' + day + '-' + rnd;
  }
  function track(ev, data, opts){
    opts = opts || {}; if(!opts.eventID) opts.eventID = evid();
    try{ if(window.fbq) fbq('track', ev, data, opts); }catch(e){}
    try{ if(window.ttq){ var m={AddToCart:'AddToCart',InitiateCheckout:'InitiateCheckout',Purchase:'CompletePayment',ViewContent:'ViewContent'}; ttq.track(m[ev]||ev, data, {event_id: opts.eventID}); } }catch(e){}
    try{ if(window.dataLayer) dataLayer.push({event:'lw_'+ev, event_id: opts.eventID, ecommerce:data}); }catch(e){}
  }
  function sel(){ return box.querySelector('input[name="variant"]:checked'); }
  function qty(){ return Math.max(1, parseInt(q('[data-lwc-qty]').textContent,10) || 1); }
  function setQty(n){
    n = Math.max(1, Math.min(20, n));
    q('[data-lwc-qty]').textContent = n;
    q('[data-lwc-dec]').disabled = n <= 1;
    calc();
  }
  function calc(){
    var r = sel(); if(!r) return;
    var n = qty();
    var price = parseInt(r.dataset.price,10);
    var sub = price * n;
    var free = r.dataset.free === '1' || sub >= FREE_FROM;
    var ship = free ? 0 : parseInt(box.dataset.ship,10);
    cur = { id:r.value, price:price, qty:n, sub:sub, ship:ship, total:sub+ship, name:r.dataset.name, title:r.dataset.title, subtitle:r.dataset.sub };
    box.querySelectorAll('.lwc-vars label').forEach(function(l){ l.setAttribute('data-on', l.contains(r)?'1':'0'); });
    q('[data-lwc-vprice]').textContent = fmt(price);
    q('[data-lwc-sub]').textContent = cur.name + ' · ' + cur.subtitle;
    q('[data-lwc-sub-total]').textContent = fmt(sub) + (n > 1 ? ' ('+n+' × '+fmt(price)+')' : '');
    var sh = q('[data-lwc-ship]'); sh.textContent = free ? 'Offerte' : fmt(ship); sh.className = free ? 'free' : '';
    q('[data-lwc-total]').textContent = fmt(cur.total);
  }
  function reset(){
    box.setAttribute('data-done','0');
    var btn = q('[data-lwc-submit]'); btn.disabled = false; btn.textContent = 'Confirmer la commande';
    var err = q('[data-lwc-error]'); err.style.display = 'none'; err.textContent = '';
    form.querySelectorAll('.err').forEach(function(el){ el.classList.remove('err'); });
  }
  function open(variantId, n){
    if(!box) return;
    reset();
    if(variantId){ var r = box.querySelector('input[name="variant"][value="'+variantId+'"]'); if(r) r.checked = true; }
    setQty(n || 1);
    box.setAttribute('data-open','1'); document.body.style.overflow='hidden';
    setTimeout(function(){ var f=q('input[name="name"]'); if(f && window.innerWidth>600) f.focus(); },50);
    track('InitiateCheckout', {value: cur.total/100, currency: currency, content_ids:[cur.id], content_type:'product', num_items:cur.qty});
  }
  function close(){ box.setAttribute('data-open','0'); document.body.style.overflow=''; }
  function pageSelection(el){
    var f = el && el.closest ? el.closest('form') : null;
    if(!f) f = document.querySelector('form[action*="/cart/add"]');
    var r = (f || document).querySelector('.vopt input:checked');
    var qi = f ? f.querySelector('input[name="quantity"]') : null;
    return { id: r ? r.value : null, qty: qi ? parseInt(qi.value,10) || 1 : 1, hasPicker: !!(f && f.querySelector('.variants')) };
  }
  function showErr(m){ var e=q('[data-lwc-error]'); e.textContent=m; e.style.display='block'; }
  function submit(e){
    e.preventDefault();
    var err = q('[data-lwc-error]'); err.style.display='none';
    var ok = true, f = {};
    ['name','phone','address'].forEach(function(k){
      var el = form.elements[k]; f[k] = (el.value||'').trim();
      var bad = !f[k];
      if(k==='phone'){ var d=f[k].replace(/\D/g,''); if(d.length===11 && d.indexOf('216')===0) d=d.slice(3); if(d.length!==8) bad=true; else f[k]=d; }
      el.classList.toggle('err', bad); if(bad) ok=false;
    });
    if(!ok){ showErr('Merci de vérifier les champs en rouge (téléphone : 8 chiffres).'); return; }
    var btn = q('[data-lwc-submit]'); btn.disabled = true; btn.textContent = 'Envoi…';
    var eventId = evid();
    var fallbackRef = orderRef();
    var ts = new Date().toISOString();
    var payload = {
      name:f.name, phone:'+216'+f.phone, gov:'', city:'', address:f.address, note:'',
      variant_id: cur.id, variant_title: cur.title, product: 'LANDWASH Nettoyant Intérieur 3 en 1', qty: cur.qty,
      price: cur.price/100, subtotal: cur.sub/100, shipping: cur.ship/100, total: cur.total/100, currency: currency,
      source: location.href, ua: navigator.userAgent, ts: ts,
      event_id: eventId, fbp: cookie('_fbp'), fbc: cookie('_fbc')
    };
    var img = q('.lwc-prod img');
    var order = {
      ref: fallbackRef, shopify_name: '', event_id: eventId, ts: ts, name: f.name, phone: f.phone, address: f.address,
      items: [{ variant_id: cur.id, name: cur.name, subtitle: cur.subtitle, qty: cur.qty, price: cur.price, line: cur.sub, image: img ? img.src : '' }],
      subtotal: cur.sub, shipping: cur.ship, total: cur.total, currency: currency
    };
    var ep = box.dataset.endpoint;
    var line = cur.qty + ' × ' + cur.name;
    var done = function(resp){
      var ref = (resp && resp.lw_ref) ? resp.lw_ref : fallbackRef;
      order.ref = ref;
      order.shopify_name = (resp && resp.order_name) ? resp.order_name : '';
      order.shopify_id = (resp && resp.order_id) ? resp.order_id : '';
      try{ localStorage.setItem('lw_last_order', JSON.stringify({t:Date.now(),v:cur.id,ref:ref,shopify:order.shopify_name})); }catch(e){}
      var confirmUrl = box.dataset.confirm, stored = false;
      try{ sessionStorage.setItem('lw_order', JSON.stringify(order)); stored = true; }catch(e){}
      if(confirmUrl && stored){
        location.href = confirmUrl + (confirmUrl.indexOf('?') > -1 ? '&' : '?') + 'ref=' + encodeURIComponent(ref);
        return;
      }
      track('Purchase', {value: payload.total, currency: currency, content_ids:[cur.id], content_type:'product', num_items:cur.qty}, {eventID: eventId});
      q('[data-lwc-name]').textContent = f.name.split(' ')[0];
      q('[data-lwc-phone]').textContent = f.phone.replace(/(\d{2})(\d{3})(\d{3})/,'$1 $2 $3');
      var msg = 'Bonjour LANDWASH, je viens de commander '+line+' ('+fmt(cur.total)+'). Commande : '+ref+', Nom : '+f.name+', Tél : '+f.phone;
      q('[data-lwc-wa]').href = 'https://wa.me/'+box.dataset.wa+'?text='+encodeURIComponent(msg);
      box.setAttribute('data-done','1');
      form.reset();
    };
    var fail = function(){
      btn.disabled=false; btn.textContent='Confirmer la commande';
      var msg = 'Bonjour LANDWASH 👋 Je veux commander : '+line+' — '+fmt(cur.total)+'.\nNom : '+f.name+'\nTél : '+f.phone+'\nAdresse : '+f.address;
      err.innerHTML = 'Connexion impossible. <a style="color:#fff;text-decoration:underline" target="_blank" rel="noopener" href="https://wa.me/'+box.dataset.wa+'?text='+encodeURIComponent(msg)+'">Envoyer la commande via WhatsApp →</a>';
      err.style.display='block';
    };
    if(!ep){ fail(); return; }
    fetch(ep, { method:'POST', mode:'cors', redirect:'follow', headers:{'Content-Type':'text/plain;charset=utf-8'}, body: JSON.stringify(payload) })
      .then(function(r){ return r.json(); })
      .then(function(j){ if(j && j.ok){ done(j); } else { try{ console.error('LW relay', j); }catch(e){} fail(); } })
      .catch(function(er){ try{ console.error('LW relay', er); }catch(e){} fail(); });
  }
  document.addEventListener('DOMContentLoaded', function(){
    box = document.getElementById('lw-checkout'); if(!box) return;
    form = box.querySelector('.lwc-form');
    currency = box.dataset.currency || 'TND';
    q('.lwc-bg').addEventListener('click', close);
    q('.lwc-x').addEventListener('click', close);
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });
    box.querySelectorAll('input[name="variant"]').forEach(function(r){ r.addEventListener('change', calc); });
    q('[data-lwc-dec]').addEventListener('click', function(){ setQty(qty()-1); });
    q('[data-lwc-inc]').addEventListener('click', function(){ setQty(qty()+1); });
    var again = q('[data-lwc-again]'); if(again) again.addEventListener('click', function(){ reset(); setQty(1); });
    form.addEventListener('submit', submit);
    document.querySelectorAll('[data-lw-buynow],[data-lw-sticky]').forEach(function(b){
      b.addEventListener('click', function(e){
        e.preventDefault(); e.stopImmediatePropagation();
        var s = pageSelection(b);
        // Pas de pack choisi sur la page : on renvoie au sélecteur au lieu d'imposer un pack
        if(!s.id && s.hasPicker && window.lwCart && window.lwCart.pick){ window.lwCart.pick(); return; }
        open(s.id, s.qty);
      }, true);
    });
    document.querySelectorAll('[data-lw-drawer-buy]').forEach(function(b){
      b.addEventListener('click', function(e){
        e.preventDefault(); e.stopImmediatePropagation();
        var dw=document.getElementById('lw-drawer'); if(dw){ dw.setAttribute('data-open','0'); document.body.style.overflow=''; }
        var c = window.lwCart && window.lwCart.state();
        if(c && c.items && c.items.length){ open(String(c.items[0].variant_id), c.items[0].quantity); }
        else { var s = pageSelection(null); if(!s.id && s.hasPicker && window.lwCart && window.lwCart.pick){ window.lwCart.pick(); return; } open(s.id, 1); }
      }, true);
    });
    var pv = box.querySelector('input[name="variant"]:checked');
    if(pv && !document.getElementById('lw-order')) track('ViewContent', {content_ids:[pv.value], content_type:'product', value: parseInt(pv.dataset.price,10)/100, currency: currency});
  });
  window.lwCheckout = { open: open, close: close, track: track, fmt: fmt };
})();
